<template>
  <div :class="classes">
     <pt-page-title :title="(isEdit?'编辑':'新建')+'商品'"></pt-page-title>
     <div v-loading="loading" :class="$style['goods-form-detail']">
      <goods-form ref="goodsForm" @selectLabs="selectLabs" :goodsForm="goodsForm" :content="content" :is-edit="isEdit" :goodsGroup="goodsGroup" @typeChange="typeChange"
      @selectMeal="selectMeal" :genePackage="genePackage" :afterSalesPolicieList="afterSalesPolicieList" @addAfterSalesPolicie="addAfterSalesPolicie" :id="id"
      :vendors-organizations="vendorsOrganizations" :selectLabels="selectLabels" :goodsTypes="goodsTypes" @getGoodsTypeList="getGoodsTypeList" :goodsTypeLoading="goodsTypeLoading"
      :carriagePoliciesList="carriagePoliciesList"  :afterSalesPolicy="afterSalesPolicy" :carriagePolicy="carriagePolicy"  :privacyPolicyList="privacyPolicyList"
      :privacyPolicy="privacyPolicy" @selectTax="selectTax" :tax-project="taxProject" @getCompany="getCompany" :companyList="companyList"
      :companyListWechat="companyListWechat" :businessDepartments="businessDepartments"></goods-form>
      <div class="button-div">
          <el-button type="primary" @click="submitData" :loading="submitLoading||saveLoading">提交</el-button>
          <el-button type="primary" plain :class="$style['submit-button']" @click="save" :loading="saveLoading||submitLoading">保存</el-button>
          <el-button type="primary" plain :class="$style['submit-button']" @click="cancel">取消</el-button>
      </div>
     </div>

      <el-dialog :visible="is_dialog" :title="dialog_title" @close="closeDialog()" :class="{'sales-dialog':is_after_sales,'privacy-policies-dialog':hasSimditorTextarea}">
          <select-for-labels v-if="is_select_labels" @selectLabelsSubmit="selectLabelsSubmit" @close="closeDialog" :selectLabels="selectLabels"></select-for-labels>
          <meal-list v-if="is_select_meal" @selectMealList="selectMealList" @closeDialog="closeDialog" :genePackage="genePackage"></meal-list>
          <new-after-sales-policie v-if="is_after_sales"  @closeDialog="closeDialog" :policyType="policyType" :policyContentMax="policyContentMax"></new-after-sales-policie>
          <select-for-taxation @closeDialog="closeDialog" @submitTax="submitTax" v-if="is_taxation" :selectedTax="taxProject"></select-for-taxation>
          <!-- <select-for-labels></select-for-labels> -->
      </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import goodsForm from './form'
// import labelsList from './labels-list'
import mealList from './meal-list'
import newAfterSalesPolicie from './new-after-sales-policie'
import selectForLabels from './select-for-labels'
import selectForTaxation from '../../select-for-taxation'
import { cashCount, isEmptyObject } from 'utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-goods-form'

export default {
  name: 'pt-goods-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    form () {
      return this.$refs.goodsForm
    },
    is_dialog: {
      get: function () {
        return this.is_select_labels || this.is_select_meal || this.is_after_sales || this.is_taxation
      },
      set: function (val) {
        this.is_select_labels = val
        this.is_select_meal = val
        this.is_after_sales = val
        this.is_taxation = val
      }
    },
    goodsData () {
      return this.goodsForm.goodsDTO && this.goodsForm.goodsDTO.goodsData
    },
    // 是否是基因商品
    isGene () {
      return this.form.form && this.form.form.goodsDTO && this.form.form.goodsDTO.goodsData && this.form.form.goodsDTO.goodsData.type === 'GENE'
    },
    justShow () {
      return this.form.form && this.form.form.goodsDTO && this.form.form.goodsDTO.goodsData && this.form.form.goodsDTO.goodsData.justShow
    },
    // 是否是隐私条款
    isPrivacyPolicy () {
      return this.policyType === 'privacyPolicy'
    },
    // 是否售后政策
    isAfterSalesPolicy () {
      return this.policyType === 'afterSalesPolicy'
    },
    // dialog里面是否包含富文本
    hasSimditorTextarea () {
      return this.isPrivacyPolicy || this.isAfterSalesPolicy
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    goodsForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    goodsGroup: {
      type: Array,
      default: function () {
        return []
      }
    },
    content: {
      type: String,
      default: ''
    },
    afterSalesPolicieList: {
      type: Array,
      default: function () {
        return []
      }
    },
    carriagePoliciesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    vendorsOrganizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    goodsTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypeLoading: {
      type: Boolean,
      default: false
    },
    privacyPolicyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    companyListWechat: {
      type: Array,
      default: function () {
        return []
      }
    },
    businessDepartments: {
      type: Array
    }
  },
  components: {
    goodsForm,
    // labelsList,
    mealList,
    newAfterSalesPolicie,
    selectForLabels,
    selectForTaxation
  },
  watch: {
    goodsForm: {
      handler: function (val) {
        this.selectLabels = (val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.tags) || []
      },
      deep: true
    },
    'goodsForm.taxProjectManageDTO': {
      handler: function (val) {
        this.taxProject = val || {}
      }
    }
  },
  data () {
    return {
      formValue: {
      },
      is_select_labels: false,
      dialog_title: '',
      is_select_meal: false,
      genePackage: [],
      is_after_sales: false,
      selectLabels: [],
      policyType: 'afterSalesPolicy',
      policyContentMax: '',
      afterSalesPolicy: {},
      carriagePolicy: {},
      privacyPolicy: {},
      is_taxation: false,
      taxProject: null
    }
  },

  methods: {
    getCompany (val) {
      this.$emit('getCompany', val)
    },
    submitTax (val) {
      this.is_taxation = false
      this.taxProject = { ...val }
    },
    selectTax () {
      this.dialog_title = '选择税务项目'
      this.is_taxation = true
    },
    getGoodsTypeList (val) {
      this.$emit('getGoodsTypeList', val)
    },
    cancel () {
      history.go(-1)
    },
    selectLabelsSubmit (val) {
      this.selectLabels = JSON.parse(JSON.stringify(val))
      this.closeDialog()
    },
    addAfterSalesPolicie (type) {
      this.dialog_title = type === 'carriagePolicy' ? '新建运费模板' : (type === 'privacyPolicy' ? '新建隐私条款' : '新建售后政策')
      this.policyType = type || 'afterSalesPolicy'
      this.policyContentMax = type === 'carriagePolicy' ? 15 : null
      this.is_after_sales = true
    },
    selectMealList (val) {
      this.genePackage = []
      this.genePackage.push(val)
      this.genePackage.forEach(item => {
        item.sequencingTechnologyType = item.productBean && item.productBean.name
      })
      this.closeDialog()
    },
    typeChange (val) {
      this.$emit('typeChange', val)
    },
    selectLabs () {
      this.is_select_labels = true
      this.dialog_title = '选择标签'
    },
    selectMeal () {
      this.genePackage = (this.goodsForm.goodsDTO && this.goodsForm.goodsDTO.goodsData && this.goodsForm.goodsDTO.goodsData.genePackage) || []
      this.is_select_meal = true
      this.dialog_title = '选择检测套餐'
    },
    save () {
      this.form.form.applyForApproval = false
      this.submit()
    },
    submitData () {
      this.form.form.applyForApproval = true
      this.submit()
    },
    commit (formValue) {
      let goodsData = (formValue.goodsDTO && formValue.goodsDTO.goodsData) || {}
      // formValue.goodsDTO.businessDepartmentId = goodsData.businessDepartmentId || null
      this.businessDepartments.forEach(item => {
        if (item.id === goodsData.businessDepartmentId) {
          goodsData.businessDepartmentName = item.name
        }
      })
      goodsData.vendorInfo = goodsData.vendorInfo || {}
      goodsData.vendorInfo.organizationId = this.form.isSelectVendorsOrganizations ? goodsData.vendorInfo.organizationId : null
      goodsData.vendorInfo.organizationName = this.form.isSelectVendorsOrganizations ? goodsData.vendorInfo.organizationName : null
      // if (isEmptyObject(goodsData.vendorInfo) || (!goodsData.vendorInfo.organizationId && !goodsData.vendorInfo.organizationName)) {
      // goodsData.vendorInfo = null
      // }
      goodsData.provideInvoice = goodsData.provide_invoice !== 'false'
      let specifications = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items && goodsData.specifications[0].items[0] && goodsData.specifications[0].items[0].name) || null
      if (goodsData.justShow && !specifications) {
        this.$message.error('请填写商品规格')
      } else {
        goodsData.finalPrice = goodsData.final_price && cashCount(goodsData.final_price)
        goodsData.noSpecificationsDeposit = goodsData.noSpecificationsDeposit_show && cashCount(goodsData.noSpecificationsDeposit_show)
        if (this.isGene && !this.justShow && goodsData.genePackage && goodsData.genePackage.length > 0) {
          goodsData.genePackage.forEach(item => {
            item.packageId = item.packageId || item.id
          })
        }
        this.goodsTypes.forEach(item => {
          if (item.value === goodsData.type) {
            goodsData.typeName = item.name
          }
        })
        goodsData.afterSalesPolicyId = goodsData.afterSalesPolicyId === 'null' ? null : goodsData.afterSalesPolicyId
        this.goodsGroup.forEach(item => {
          if (goodsData.groupId && goodsData.groupId === item.id) {
            goodsData.groupName = item.name
          }
        })
        if (goodsData.specifications && goodsData.specifications.length > 0) {
          goodsData.specifications.forEach(etem => {
            etem.items.forEach(item => {
              item.price = cashCount(item.show_price)
              item.deposit = cashCount(item.deposit_show)
              this.$delete(item, 'show_price')
              this.$delete(item, 'deposit_show')
              this.$delete(item, 'show_price_payment')
              this.$delete(item, 'balance_show')
            })
          })
        }
        goodsData.genePackage = goodsData.genePackage && goodsData.genePackage.length > 0 ? goodsData.genePackage : null
        this.$emit('submit', formValue)
      }
    },
    submit () {
      this.form.validate('form').then(formValue => {
        let goodsData = (formValue.goodsDTO && formValue.goodsDTO.goodsData) || {}
        if (!goodsData.carriagePolicyId && !goodsData.carriagePolicy) {
          this.$alert('您未设置运费规则，该商品运费将默认显示为“免运费”。', '运费规则提示', {
            confirmButtonText: '确定',
            type: 'warning' }).then(_ => {
            this.commit(formValue)
          })
        } else {
          this.commit(formValue)
        }
      })
    },
    closeDialog (data) {
      this.is_dialog = false
      if (data) {
        if (this.policyType === 'carriagePolicy') {
          this.$emit('getCarriagePolicies')
          this.carriagePolicy = data
        } else if (this.policyType === 'privacyPolicy') {
          this.$emit('getPrivacyPolicies')
          this.privacyPolicy = data
        } else if (this.policyType === 'afterSalesPolicy') {
          this.$emit('afterSalesPolicies')
          this.afterSalesPolicy = data
        } else {
          console.error('未定义type')
        }
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.submit-button{
    margin-left: 30px!important
}
.goods-form-detail{
    position: relative;
}
:global
.sales-dialog{
    .el-dialog{
        width:35%;
        max-width: 700Px;
        display:flex;
        flex-direction: column;
        .el-dialog__body{
            display: flex;
            flex:1;
        }
    }
}
:global
.privacy-policies-dialog{
    .el-dialog{
        width:55%;
        max-width: 800Px;
        display:flex;
        flex-direction: column;
        .el-dialog__body{
            display: flex;
            flex:1;
        }
    }
}
</style>
